import React, { useState } from 'react';
import Button from 'components/general/button/Button';
import OptionButton from '../OptionButton';

interface WorkPermitStepProps {
  optionWorkPermit: boolean | null;
  onNext: (hasWorkPermit: boolean) => void;
  onPrevious: () => void;
}

const WorkPermitStep: React.FC<WorkPermitStepProps> = ({
  optionWorkPermit,
  onNext,
  onPrevious,
}) => {
  const styles = require('./Step.module.scss');
  const [hasWorkPermit, setHasWorkPermit] = useState<boolean | null>(optionWorkPermit);
  
  return (
    <>
      <div className={styles.form}>
        <OptionButton
          label="Yes"
          isSelected={hasWorkPermit === true}
          onClick={() => setHasWorkPermit(true)}
        />
        <OptionButton
          label="No"
          isSelected={hasWorkPermit === false}
          onClick={() => setHasWorkPermit(false)}
        />
      </div>

      <div className={styles.footer}>
        {onPrevious && (
          <Button
            onClick={onPrevious}
            type="Secondary"
            size="M"
            iconLeftName="chevronLeft"
            className={styles.actionButton}
          >
            Previous
          </Button>
        )}

        <Button
          onClick={() => onNext(hasWorkPermit)}
          disabled={hasWorkPermit === null}
          size="M"
          iconRightName="chevronRight"
          className={styles.actionButton}
        >
          Next
        </Button>
      </div>
    </>
  );
};

export default WorkPermitStep;
